'use client';
import { ShoppingCart } from '@phosphor-icons/react';
import { useCart } from '@/lib/cart/CartContext';
import { useCartDrawer } from '@/lib/cart/CartContext';
import { useLocale } from 'next-intl';

export default function CartIcon() {
  const { lineCount } = useCart();
  const { openDrawer } = useCartDrawer();
  const locale = useLocale();

  return (
    <button
      onClick={openDrawer}
      aria-label={locale === 'ar' ? 'سلة التسوق' : 'Shopping cart'}
      className="tap-target relative inline-flex items-center justify-center w-10 h-10 text-foreground hover:text-primary transition-colors rounded-lg focus-visible:ring-2 focus-visible:ring-ring"
    >
      <ShoppingCart size={22} />
      {lineCount > 0 && (
        <span
          key={lineCount}
          dir="ltr"
          className="absolute -top-0.5 -end-0.5 bg-primary text-primary-foreground rounded-full min-w-[16px] h-4 px-[3px] text-[10px] font-bold flex items-center justify-center leading-none select-none animate-in zoom-in duration-200"
        >
          {lineCount > 99 ? '99+' : lineCount}
        </span>
      )}
    </button>
  );
}
